import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { GALLERY, VOLUMES } from '../../data/catio';

/** Post-offer research: every volume in a compact accordion. */
export function VolumeDetailSection() {
  const [open, setOpen] = useState<string | null>(null);
  return <section aria-labelledby="volumes-detail-title" className="bg-paper py-12 sm:py-20" data-id="element-338" data-mp="1uxkifb9bcjj9">
      <div className="mx-auto grid w-full max-w-6xl gap-7 px-5 sm:px-8 lg:grid-cols-12 lg:gap-14" data-id="element-339" data-mp="y94n0yjivfy8">
        <div className="lg:col-span-4" data-id="element-340" data-mp="137po106lm3nq">
          <h2 id="volumes-detail-title" className="font-display text-[1.85rem] leading-[1.12] text-ink sm:text-[2.6rem]" data-id="element-341" data-mp="178jf22fc7yku">
            Explore Each Volume in More Detail
          </h2>
          <p className="mt-3 text-[1rem] leading-relaxed text-graphite" data-id="element-342" data-mp="fhvfgutbb19a">
            Five volumes, eight complete projects in each.
          </p>
        </div>

        <ul className="divide-y divide-line border-y border-line lg:col-span-8" data-id="element-343" data-mp="jgugi4bxadvg">
          {VOLUMES.map(volume => {
          const isOpen = open === volume.id;
          const previews = GALLERY.filter(p => p.volume === volume.number);
          return <li key={volume.id} id={`volume-${volume.number}`} data-id="element-344" data-mp="1m78aiq7qh999">
                <h3 data-id="element-345" data-mp="1h9q16ypt0s0q">
                  <button type="button" onClick={() => setOpen(isOpen ? null : volume.id)} aria-expanded={isOpen} aria-controls={`volume-panel-${volume.id}`} className="flex min-h-[76px] w-full items-center gap-4 py-3 text-left focus:outline-none focus-visible:ring-4 focus-visible:ring-ember/30" data-id="element-346" data-mp="1h8evuugpnc7i">
                    <img src={volume.cover} alt="" width={1530} height={1980} loading="lazy" decoding="async" className="aspect-[1530/1980] w-11 shrink-0 rounded-[3px] object-cover ring-1 ring-black/10" data-id="element-347" data-mp="yc58thntzbbd" />
                    <span className="min-w-0 flex-1" data-id="element-348" data-mp="vr7kkvb2l9ju">
                      <span className="label-tech block text-ember" data-id="element-349" data-mp="vrz7ziuik0z1">
                        Volume {volume.number} · 8 projects
                      </span>
                      <span className="mt-0.5 block font-display text-[1.15rem] leading-tight text-ink sm:text-[1.3rem]" data-id="element-350" data-mp="m14j06pvun9w">
                        {volume.title}
                      </span>
                    </span>
                    <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-colors duration-150 ease-out ${isOpen ? 'border-ink bg-ink text-cream' : 'border-ink/20 text-ink'}`} aria-hidden data-id="element-351" data-mp="1eo8rilo6pjqf">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-352" data-mp="3phl0l2g2j180" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-353" data-mp="2gkmvol8njtzr">
                  {isOpen && <motion.div id={`volume-panel-${volume.id}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.24,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-354" data-mp="2cijh3nqos9a9">
                      <div className="pb-6 pt-1" data-id="element-355" data-mp="1su0o0v2k8bqa">
                        <p className="text-[1rem] leading-relaxed text-graphite" data-id="element-356" data-mp="1st94iim8m4gd">{volume.copy}</p>
                        <ul className="mt-3 grid gap-1.5" data-id="element-357" data-mp="15350wb91u4pd">
                          {volume.bullets.map(bullet => <li key={bullet} className="flex items-center gap-3 text-[0.96rem] font-medium text-ink" data-id="element-358" data-mp="111jp6t893wgr">
                              <span className="h-1.5 w-1.5 shrink-0 rotate-45 bg-ember" aria-hidden data-id="element-359" data-mp="1nqrsc854j2gd" />
                              {bullet}
                            </li>)}
                        </ul>
                        <p className="label-tech mt-5 text-graphite" data-id="element-360" data-mp="1xhcjxbmdr6ps">
                          Previewed on this page
                        </p>
                        <ul className="mt-2 grid grid-cols-3 gap-2 sm:gap-3" data-id="element-361" data-mp="21k9aboi5w74a">
                          {previews.map(project => <li key={project.src} data-id="element-362" data-mp="2bgvtm8uuaq47">
                              <img src={project.src} alt={project.alt} width={project.width} height={project.height} loading="lazy" decoding="async" className="aspect-[1530/1980] w-full rounded-[6px] object-cover ring-1 ring-black/5" data-id="element-363" data-mp="2bfkpu91e9id3" />
                              <p className="mt-1.5 text-[0.78rem] font-medium leading-snug text-graphite" data-id="element-364" data-mp="3vywiw2s65oux">
                                {project.title}
                              </p>
                            </li>)}
                        </ul>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}